/**
 * Générateur — Automatisme : résoudre des équations du type ax + b = c.
 * Attendu ID : 1226 | Niveau : 3ème | Domaine : Calcul littéral et algébrique
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 11, ligne 794).
 *
 * Les clés etapes_* de gen_1225 (un fichier « équations », deux jeux de clés,
 * modèle 1213/1246, base du prof du 13/09) : tireurs, distracteurs et
 * sacrifiés sont ceux de gen_1225 ; les payloads portent déjà l'attendu 1226.
 */
import { genererParmi, CATEGORIES_ETAPES } from './gen_1225';

export const CATEGORIES = CATEGORIES_ETAPES;
const CLES = CATEGORIES_ETAPES.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
